import { createContext, useContext, useMemo, useState } from "react";

const initialState = {
  open: false,
  type: null,
  id: null,
  data: null,
  dataNode: null,
  originType: null,
  hasProps: {
    hasDescripcion: false,
    hasEntradas: false,
    hasRespuestas: false,
    hasExtensions: false,
    hasParams: false,
    hasDefaultResponse: false,
  },
};

export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [sidebar, setSidebar] = useState(initialState);

  const openSidebar = ({ id, type, data, originType = null, dataNode }) => {
    setSidebar({ open: true, id, type, data, originType, dataNode });
  };

  const closeSidebar = () => {
    setSidebar((prev) => ({ ...prev, open: false }));
  };

  const setHasProps = (props) => {
    setSidebar((prev) => ({
      ...prev,
      hasProps: {
        ...prev.hasProps,
        ...props,
      },
    }));
  };

  const value = useMemo(
    () => ({
      sidebar,
      openSidebar,
      closeSidebar,
      setHasProps,
    }),
    [sidebar]
  );

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
